/**
 * Paths that render without the shell (sign-in, MFA, password reset). The
 * identity module (WP0-AUTH) owns these pages; see
 * docs/requests/wp0-shell-route-chrome.md for a manifest flag to replace this.
 */
export const BARE_PATH_PREFIXES = [
  '/login',
  '/auth/',
  '/logout',
  '/mfa',
  '/support/',
  '/f/',
  '/i/',
  '/new-patient/',
  // Patient forms inside an office website's iframe (forms-share).
  '/embed/',
  // The public, read-only Help Center (no sign-in, no patient data).
  '/help/public',
];

export function isBarePath(pathname: string): boolean {
  return BARE_PATH_PREFIXES.some(
    (p) => pathname === p || pathname.startsWith(p.endsWith('/') ? p : `${p}/`),
  );
}

/**
 * Paths that render inside the signed-in shell (session, office scope, live
 * updates) but without its chrome: the desktop app's own small windows, such
 * as the always-on-top call pop (`/desktop/call-pop`, apps/desktop).
 */
export const CHROMELESS_PATH_PREFIXES = ['/desktop/'];

export function isChromelessPath(pathname: string): boolean {
  return CHROMELESS_PATH_PREFIXES.some((p) => pathname.startsWith(p));
}
